export default function InputSkeleton() {
  return (
    <div
      className="form-control animate-pulse h-10"
      style={{ backgroundColor: "var(--cs-soft-secondary)" }}
    ></div>
  );
}
